var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9983 36C19.9983 36 32.52 24.8696 32.52 16.5217C32.52 9.60617 26.9139 4 19.9983 4C13.0827 4 7.47656 9.60617 7.47656 16.5217C7.47656 24.8696 19.9983 36 19.9983 36Z",
    stroke: "#01C37D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9988 16.0003C23.9988 18.2094 22.208 20.0003 19.9988 20.0003C17.7897 20.0003 15.9988 18.2094 15.9988 16.0003C15.9988 13.7911 17.7897 12.0003 19.9988 12.0003C22.208 12.0003 23.9988 13.7911 23.9988 16.0003Z",
    stroke: "#01C37D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker02);
export default __webpack_public_path__ + "static/media/marker-02.0c3bfcda50ced60a46c5a3f97396b85b.svg";
export { ForwardRef as ReactComponent };